<div class="modal fade" #modalStatus id="modal-status" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-xs modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h3 [lang]="lang" class="text-uppercase">{{ 'reservations.changeReservationStatus' | translate | uppercase }}</h3>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">&times;</button>
            </div>
            <div class="modal-body pb-3 pb-sm-4">
                <button *ngFor="let relevantStatus of relevantStatuses" class="btn btn-sec btn-sec-icon w-100 mb-1"
                    data-bs-dismiss="modal"
                    [class.active]="changeStatusReservation?.reservationDetails?.reservationsStatus == relevantStatus.id"
                    (click)="changeStatus(relevantStatus.id)"><img class="icon-status" [src]="relevantStatus.img">
                    {{ 'reservations.statuses.' + relevantStatus.id.toLowerCase() | translate }}
                </button>
                <div id="modal-status-collapse" class="collapse">
                    <button *ngFor="let lessRelevantStatus of lessReleventStatuses" class="btn btn-sec btn-sec-icon w-100 mb-1"
                        data-bs-dismiss="modal"
                        [class.active]="changeStatusReservation?.reservationDetails?.reservationsStatus == lessRelevantStatus.id"
                        (click)="changeStatus(lessRelevantStatus.id)"><img class="icon-status" [src]="lessRelevantStatus.img">
                        {{ 'reservations.statuses.' + lessRelevantStatus.id.toLowerCase() | translate }}
                    </button>
                </div>
                <a class="d-block text-end text-sm py-2" data-bs-toggle="collapse"
                    data-bs-target="#modal-status-collapse">
                    <span class="collapse-closed">{{ 'reservations.showAll' | translate }}</span>
                    <span class="collapse-open">{{ 'reservations.hideLessRelevant' | translate }}</span>
                </a>
            </div>
        </div>
    </div>
</div>